import React from 'react';
import Css from './PricingRow.scss';
import CurrencyFormat from 'react-currency-format';
import PriceTooltip from './PriceTooltip/PriceTooltip';
import FlightTime from '@components/FlightTime/FlightTime';

const pricingRow = props => {
  const { P100, P300, p300Only, contractVersion } = props;
  return (
    <div className={Css.container}>
      <div className={Css.header + ' lakes-medium font-sm text-left'}>
        LEG {props.index}
      </div>

      <div className={Css.content + ' background-white p-3'}>
        <table
          className={
            Css.table + ' table table-sm table-jetsuite font-sm text-left'
          }
        >
          <thead>
            <tr>
              <th style={{ width: '25%' }}>Flight Route</th>
              <th style={{ width: '25%' }} className={'color-red'}>
                P100
              </th>
              <th style={{ width: '25%' }} className={'color-red'}>
                P300
              </th>
              {/*<th style={{ width: '25%' }} className={'color-red'}>
                L650
              </th>*/}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Departure Airport</td>
              <td>{P100.departure_airport.name}</td>
              <td>{P300.departure_airport.name}</td>
              {/*<td>
                {L650.departure_airport === undefined
                  ? 'n/a'
                  : L650.departure_airport.name}
              </td>*/}
            </tr>
            <tr>
              <td>Arrival Airport</td>
              <td>{P100.arrival_airport.name}</td>
              <td>{P300.arrival_airport.name}</td>
              {/*<td>
                {L650.arrival_airport === undefined
                  ? 'n/a'
                  : L650.arrival_airport.name}
              </td>*/}
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>Departure Date</td>
              <td>{P100.departure_datetime.split(' ')[0]}</td>
              <td>{P300.departure_datetime.split(' ')[0]}</td>
              {/*<td>
                {L650.departure_datetime === undefined
                  ? 'n/a'
                  : L650.departure_datetime.split(' ')[0]}
              </td>*/}
            </tr>
            <tr>
              <td>Departure Time (local)</td>
              <td>
                {P100.departure_datetime.split(' ')[1]}{' '}
                {P100.departure_datetime.split(' ')[2]}
              </td>
              <td>
                {P300.departure_datetime.split(' ')[1]}{' '}
                {P300.departure_datetime.split(' ')[2]}
              </td>
              {/*<td>
                {L650.departure_datetime !== undefined ? (
                  <div>
                    {L650.departure_datetime.split(' ')[1]}{' '}
                    {L650.departure_datetime.split(' ')[2]}
                  </div>
                ) : (
                  'n/a'
                )}
              </td>*/}
            </tr>
            <tr>
              <td>Estimated Arrival Time (local)</td>
              <td>
                {P100.arrival_datetime !== false && p300Only === false ? (
                  <span>
                    {P100.arrival_datetime.split(' ')[1]}{' '}
                    {P100.arrival_datetime.split(' ')[2]}
                  </span>
                ) : (
                  'n/a'
                )}
              </td>
              <td>
                {P300.arrival_datetime !== false ? (
                  <span>
                    {P300.arrival_datetime.split(' ')[1]}{' '}
                    {P300.arrival_datetime.split(' ')[2]}
                  </span>
                ) : (
                  'n/a'
                )}
              </td>
              {/*<td>{L650.arrival_datetime !== undefined ? 'n/a' : 'n/a'}</td>*/}
            </tr>
          </tbody>

          {contractVersion !== 2 && (
            <React.Fragment>
              <thead>
                <tr>
                  <th colSpan={3}>Components</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{P100.departure_airport.name}</td>
                  <td>
                    {P100.fees !== false && p300Only === false ? (
                      <span>
                        <CurrencyFormat
                          value={P100.fees[P100.departure_airport.id].total_fee}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        {/*<PriceTooltip
                      tooltipOpen={props.tooltipOpen}
                      index={`p100-departure-${props.index}`}
                      toggleTooltip={props.toggleTooltip}
                      fees={P100.fees[P100.departure_airport.id].items}
                    />*/}
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                  <td>
                    {P300.fees !== false ? (
                      <span>
                        <CurrencyFormat
                          value={P300.fees[P300.departure_airport.id].total_fee}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        {/*<PriceTooltip
                      tooltipOpen={props.tooltipOpen}
                      index={`p300-departure-${props.index}`}
                      toggleTooltip={props.toggleTooltip}
                      fees={P300.fees[P300.departure_airport.id].items}
                    />*/}
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                  {/*<td
                    rowSpan={P100.discount !== 0 || P300.discount !== 0 ? 5 : 4}
                    className={'color-red text-left'}
                    style={{
                      verticalAlign: 'middle',
                      borderBottom: '1px solid #ababab'
                    }}
                  >
                    For Legacy pricing, please contact JetSuite Guest Services
                    or your Sales Manager.
                  </td>*/}
                </tr>

                {(P100.discount !== 0 || P300.discount !== 0) && (
                  <tr>
                    <td>{P100.departure_airport.name} Launch Special</td>
                    <td>
                      {P100.discount !== 0 && p300Only === false ? (
                        <span className={'color-red'}>
                          <CurrencyFormat
                            value={P100.discount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </span>
                      ) : (
                        'n/a'
                      )}
                    </td>
                    <td>
                      {P300.discount !== 0 ? (
                        <span className={'color-red'}>
                          <CurrencyFormat
                            value={P300.discount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </span>
                      ) : (
                        'n/a'
                      )}
                    </td>
                  </tr>
                )}

                <tr>
                  <td>{P100.arrival_airport.name}</td>
                  <td>
                    {P100.fees !== false && p300Only === false ? (
                      <span>
                        <CurrencyFormat
                          value={P100.fees[P100.arrival_airport.id].total_fee}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        {/*<PriceTooltip
                      tooltipOpen={props.tooltipOpen}
                      index={`p100-arrival-${props.index}`}
                      toggleTooltip={props.toggleTooltip}
                      fees={P100.fees[P100.arrival_airport.id].items}
                    />*/}
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                  <td>
                    {P300.fees !== false ? (
                      <span>
                        <CurrencyFormat
                          value={P300.fees[P300.arrival_airport.id].total_fee}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        {/*<PriceTooltip
                      tooltipOpen={props.tooltipOpen}
                      index={`p300-arrival-${props.index}`}
                      toggleTooltip={props.toggleTooltip}
                      fees={P300.fees[P300.arrival_airport.id].items}
                    />*/}
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                </tr>

                <tr>
                  <td>Flight Time Rate</td>
                  <td>
                    {P100.total > 0 && p300Only === false ? (
                      <span>
                        <CurrencyFormat
                          value={
                            P100.total -
                            P100.fees[P100.arrival_airport.id].total_fee -
                            P100.fees[P100.departure_airport.id].total_fee -
                            P100.discount
                          }
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        <PriceTooltip
                          tooltipOpen={props.tooltipOpen}
                          index={`p100-rate-${props.index}`}
                          toggleTooltip={props.toggleTooltip}
                          fees={[]}
                          items={[
                            <FlightTime flight_time={P100.flight_time} />
                          ]}
                          title={'Flight Time'}
                        />
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                  <td>
                    {P300.total > 0 ? (
                      <span>
                        <CurrencyFormat
                          value={
                            P300.total -
                            P300.fees[P300.arrival_airport.id].total_fee -
                            P300.fees[P300.departure_airport.id].total_fee -
                            P300.discount
                          }
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        <PriceTooltip
                          tooltipOpen={props.tooltipOpen}
                          index={`p300-rate-${props.index}`}
                          toggleTooltip={props.toggleTooltip}
                          fees={[]}
                          items={[
                            <FlightTime flight_time={P300.flight_time} />
                          ]}
                          title={'Flight Time'}
                        />
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                </tr>
              </tbody>

              <thead>
                <tr>
                  <th>Pricing</th>
                  <th>P100</th>
                  <th>P300</th>
                  {/*<th>L650</th>*/}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>LEG 1 Total:</td>
                  <td className={'lakes-bold'}>
                    {P100.total > 0 && p300Only === false ? (
                      <CurrencyFormat
                        value={P100.total}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    ) : (
                      'n/a'
                    )}
                  </td>
                  <td className={'lakes-bold'}>
                    {P300.total > 0 ? (
                      <CurrencyFormat
                        value={P300.total}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    ) : (
                      'n/a'
                    )}
                  </td>
                  {/*<td className={'lakes-bold'}>---</td>*/}
                </tr>
              </tbody>
            </React.Fragment>
          )}

          <thead>
            <tr>
              <th>Airport {props.legInfo.fromCode}</th>
              <th colSpan={2}>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={'lakes-bold border-0'}>Catering:</td>
              <td colSpan={2} className={'border-0'}>
                <div className={'pb-2'}>
                  <input
                    type={'radio'}
                    name={props.index + '-' + props.legInfo.fromCode}
                    checked={
                      props.legInfo.from_catering_specifications === 'Yes'
                    }
                    className={'ml-1 mr-2'}
                    onClick={e =>
                      props.onSpecificationChange(
                        props.index - 1,
                        'from_catering_specifications',
                        'Yes'
                      )
                    }
                  />
                  Yes
                </div>
                <div>
                  <input
                    type={'radio'}
                    name={props.index + '-' + props.legInfo.fromCode}
                    checked={
                      props.legInfo.from_catering_specifications === 'No' ||
                      props.legInfo.from_catering_specifications === undefined
                    }
                    className={'ml-1 mr-2'}
                    onClick={e =>
                      props.onSpecificationChange(
                        props.index - 1,
                        'from_catering_specifications',
                        'No'
                      )
                    }
                  />
                  No
                </div>
              </td>
            </tr>
            <tr>
              <td className={'lakes-bold border-0'}>
                Ground Arrangement
                <br />
                Specifications:
              </td>
              <td colSpan={2} className={'border-0'}>
                <textarea
                  className={'form-control'}
                  onChange={e =>
                    props.onSpecificationChange(
                      props.index - 1,
                      'from_specifications',
                      e.target.value
                    )
                  }
                >
                  {props.legInfo.from_specifications}
                </textarea>
              </td>
            </tr>
          </tbody>

          <thead>
            <tr>
              <th>Airport {props.legInfo.toCode}</th>
              <th colSpan={2}>&nbsp;</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className={'lakes-bold border-0'}>Catering:</td>
              <td colSpan={2} className={'border-0'}>
                <div className={'pb-2'}>
                  <input
                    type={'radio'}
                    name={props.index + '-' + props.legInfo.toCode}
                    checked={props.legInfo.to_catering_specifications === 'Yes'}
                    className={'ml-1 mr-2'}
                    defaultChecked={false}
                    onClick={e =>
                      props.onSpecificationChange(
                        props.index - 1,
                        'to_catering_specifications',
                        'Yes'
                      )
                    }
                  />
                  Yes
                </div>
                <div>
                  <input
                    type={'radio'}
                    name={props.index + '-' + props.legInfo.toCode}
                    checked={
                      props.legInfo.to_catering_specifications === 'No' ||
                      props.legInfo.to_catering_specifications === undefined
                    }
                    defaultChecked={true}
                    className={'ml-1 mr-2'}
                    onClick={e =>
                      props.onSpecificationChange(
                        props.index - 1,
                        'to_catering_specifications',
                        'No'
                      )
                    }
                  />
                  No
                </div>
              </td>
            </tr>
            <tr>
              <td className={'lakes-bold border-0'}>
                Ground Arrangement
                <br />
                Specifications:
              </td>
              <td colSpan={2} className={'border-0'}>
                <textarea
                  className={'form-control'}
                  onChange={e =>
                    props.onSpecificationChange(
                      props.index - 1,
                      'to_specifications',
                      e.target.value
                    )
                  }
                >
                  {props.legInfo.to_specifications}
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default pricingRow;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Pricing/PricingRow/PricingRow.jsx